<template>
    <div>
        <p class="timeline-talks" v-html="message"></p>
    </div>
</template>

<script>
export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: ['details'],
    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {}
    },
    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        message() {
            const docExpiry =
                this.details &&
                this.details.data &&
                this.details.data.documentExpiry
            if (docExpiry) {
                const docType = docExpiry.documentType || 'Document'
                const docNum = docExpiry.documentNumber
                    ? ' No. ' + docExpiry.documentNumber
                    : ''
                const dateStr = docExpiry.expiryDate
                    ? new Date(docExpiry.expiryDate).toLocaleDateString(
                          'en-GB',
                          {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric',
                          }
                      )
                    : ''
                if (docExpiry.status === 'expired') {
                    return (
                        'Document Expiry Alert: ' +
                        docType +
                        docNum +
                        ' expired on ' +
                        dateStr +
                        ' (' +
                        docExpiry.daysExpired +
                        ' day(s) ago)'
                    )
                } else if (docExpiry.status === 'expiring_soon') {
                    return (
                        'Document Expiry Alert: ' +
                        docType +
                        docNum +
                        ' is expiring on ' +
                        dateStr +
                        ' (in ' +
                        docExpiry.daysToExpiry +
                        ' day(s))'
                    )
                }
            }
            return 'Trigger alert has been created on Delta Upload'
        },
    },
}
</script>
